import styled from '@emotion/styled'
import { ButtonLink } from '../buttons/ButtonLink/ButtonLink'
import { IconActionComment } from '../icons'
import { textMixin } from '../mixins/TextMixin/TextMixin'
import { metrics } from '../__styling'
import { breakpoint } from '../__styling/style-functions/breakpoint'
import { calcRem } from '../__styling/style-functions/calc-rem'

export const StyledHeading = styled('h2')(({ theme }) => ({
    padding: calcRem(0, 24),
    fontSize: calcRem(40),
    fontWeight: 700,
    fontFamily: theme.fonts.heading,
    margin: calcRem(metrics.thenightly.margins.m2l, 0),
    letterSpacing: calcRem(-1.6),
    lineHeight: calcRem(24),
    overflowWrap: 'break-word',
    wordBreak: 'break-word',

    [breakpoint('sm')]: {
        display: 'none',
        padding: 0,
    },
}))

export const StyledActionBox = styled('div')({
    display: 'flex',
    width: '100%',
    flexDirection: 'column',

    [breakpoint('sm')]: {
        flexDirection: 'row',
    },
})

export const StyledRegisterBox = styled('div')(({ theme }) => ({
    display: 'flex',
    flexBasis: '64%',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: theme.colors.background.tertiary,
    paddingTop: calcRem(theme.margins.md),
    paddingBottom: calcRem(theme.margins.md),
}))

export const StyledAccountBox = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundColor: theme.colors.text.primary,
    paddingBottom: calcRem(theme.margins.md),

    [breakpoint('sm')]: {
        flexBasis: '36%',
        paddingBottom: 0,
    },
}))

export const StyledCommentIcon = styled(IconActionComment)({})

export const StyledLinkButton = styled(ButtonLink)(({ theme }) => ({
    backgroundColor: theme.colors.actions.button.primary.background.default,
    padding: `${calcRem(12)} ${calcRem(24)}`,
    color: '#FFFFFF',
    textDecoration: 'none',
    fontSize: calcRem(14),
    fontWeight: 700,
}))

export const StyledRegisterText = styled('p')(({ theme }) => ({
    fontWeight: 700,
    fontSize: calcRem(24),
    fontFamily: theme.fonts.publication.headline,
    marginTop: calcRem(theme.margins.sm),
    marginBottom: calcRem(theme.margins.md),
}))

export const StyledAccountText = styled('p')(({ theme }) => ({
    fontSize: calcRem(16),
    color: '#FFFFFF',
    marginTop: calcRem(16),
    fontFamily: theme.fonts.sansSerif,

    [breakpoint('sm')]: {
        marginTop: calcRem(40),
    },
}))

export const StyledContainer = styled('div')(({ theme }) => ({
    padding: `0 ${calcRem(16)}`,

    [breakpoint('sm')]: {
        padding: 0,
    },
}))
